<template>
  <div class="d-flex-column review_card_2 gap-12 b-radius-12">
    <div class="d-flex-row space-between align-start">
      <div class="d-flex-row justify-start flex-5 gap-12">
        <img
          :src="handleAvatar(avatar, publicConfig.apiBaseUrl)"
          alt="User avatar"
          height="36"
          width="36"
          style="border-radius: 50%"
        />
        <div class="d-flex-column justify-start align-start gap-1">
          <label class="t-white font-family-2 bold-m f-w-600">{{
            username
          }}</label>
          <label class="t-grey font-family-2 regular-s f-w-400">{{
            formatNotificationTime(created_at)
          }}</label>
        </div>
      </div>

      <div class="d-flex-row justify-end">
        <RatingIcon v-for="rev in rating" />
      </div>
    </div>

    <p class="t-white font-family-2 regular-l">{{ review }}</p>
  </div>
</template>

<script setup>
import RatingIcon from "../icons/RatingIcon.vue";
const { public: publicConfig } = useRuntimeConfig();

const props = defineProps({
  review: {
    default: "",
  },
  username: {
    default: "",
  },
  avatar: {
    default: "",
  },
  rating: {
    default: 5,
  },
  detail: {
    default: null,
  },
  created_at: {
    default: null,
  },
});
</script>

<style lang="scss">
.review_card_2 {
  border: 1px solid var(--stroke-dark);
  padding: 18px;
}
</style>
